import produce from '../../produce';

import * as types from './types';
import { promotions as staticPromotionContent } from '../../../cms-generals';

const initialState = {
  content: staticPromotionContent
};

/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
const reducer = produce((draft, action) => {
  switch (action.type) {
    case types.PROMOTIONS_SET_PROMOS:
      draft.content = action.payload;
      break;
  }
}, initialState);

export default reducer;
